module.exports = __webpack_public_path__ + "img/logo_white.15323057.png";